module.exports = __webpack_public_path__ + "static/media/coins.4db67981.svg";